import React from "react";
import { Typography } from "material-ui";
import { Grid } from "material-ui";
import TileIcon from "./TileIcon";
import WorkOrderImage from "./../../../images/ordentrabajo_consulta.png";

const WorkOrdersTile = props => {
  const { data, lang } = props;
  const workOrders = data.OrdenesTrabajo;

  return (
    <div className="dashboard-tile">
      <TileIcon color="#f38a21" image={WorkOrderImage} />
      <div className="tile-header">{lang.OrdenesDeTrabajo}</div>
      <div className="tile-body">
        {workOrders.length == 0 && (
          <Typography
            style={{ marginTop: "2rem" }}
            variant="display1"
            align="center"
          >
            {lang.SinOrdenesDeTrabajo}
          </Typography>
        )}
        {workOrders.length > 0 && (
          <Typography
            style={{ marginTop: "2rem" }}
            variant="display1"
            align="center"
          >
            {workOrders.length}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default WorkOrdersTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/WorkOrdersTile.js